var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "top-nav" }, [
        _c("div", { staticClass: "container" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("ul", { staticStyle: { float: "right" } }, [
            !_vm.loginStatus
              ? _c("li", [
                  !_vm.loginStatus
                    ? _c(
                        "span",
                        {
                          staticStyle: { "margin-right": "20px" },
                          on: { click: _vm.login }
                        },
                        [
                          _c("img", {
                            staticStyle: { width: "20px" },
                            attrs: { src: "/static/img/login.png", alt: "" }
                          }),
                          _vm._v(" 登录\n          ")
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.loginStatus
              ? _c("li", [
                  _c("span", [
                    _c(
                      "a",
                      {
                        staticStyle: { color: "white" },
                        attrs: {
                          href: "javascript:;",
                          rel: "noopener noreferrer"
                        },
                        on: {
                          click: function($event) {
                            _vm.jumptohome("home")
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "18px" },
                          attrs: { src: "/static/img/Uhome.png", alt: "" }
                        }),
                        _vm._v(" 云系统首页\n            ")
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.loginStatus
              ? _c("li", [
                  _c(
                    "span",
                    { staticClass: "user-info" },
                    [
                      _c("span", { staticClass: "user-name" }, [
                        _vm._v(
                          "欢迎您，" +
                            _vm._s(
                              _vm.account.realname || _vm.account.username
                            ) +
                            " |"
                        )
                      ]),
                      _vm._v(" "),
                      _vm.hasCompanyId && _vm.companyList.length > 1
                        ? _c(
                            "span",
                            { staticClass: "change-company" },
                            [
                              _c(
                                "el-dropdown",
                                {
                                  staticClass: "el-dropdown",
                                  attrs: { placement: "bottom" },
                                  on: { command: _vm.changeCompany }
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "el-dropdown-link" },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.account.defaultCompany.name
                                          ) +
                                          "\n                  "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      staticClass: "dropdown-menu-company",
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        { attrs: { disabled: "" } },
                                        [_vm._v("您可以切换至以下账户：")]
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.companyList, function(d, i) {
                                        return _c(
                                          "el-dropdown-item",
                                          { key: i, attrs: { command: d } },
                                          [_vm._v(_vm._s(d.name))]
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.hasCompanyId
                        ? _c("span", [
                            _vm._v(_vm._s(_vm.account.defaultCompany.name))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasCompanyId
                        ? _c(
                            "a",
                            {
                              staticClass: "btn-logout",
                              on: {
                                click: function($event) {
                                  _vm.logout()
                                }
                              }
                            },
                            [_vm._v("[退出]")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasCompanyId
                        ? _c(
                            "el-button",
                            {
                              staticClass: "x-btn",
                              attrs: { size: "mini", type: "primary" },
                              on: {
                                click: function($event) {
                                  _vm.loginDefault()
                                }
                              }
                            },
                            [_vm._v("进入系统")]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.hasCompanyId
                    ? _c("span", { staticStyle: { cursor: "default" } }, [
                        _vm._v("个人账户")
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasCompanyId
                    ? _c(
                        "a",
                        {
                          staticStyle: { "margin-right": "4px" },
                          attrs: {
                            href: _vm.$url.accountCenter + "/index.html",
                            target: "_blank"
                          }
                        },
                        [
                          _c("span", { staticStyle: { color: "white" } }, [
                            _vm._v("| 账户中心")
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "navbar-inverse", attrs: { id: "navigation" } },
        [
          _c(
            "div",
            {
              staticClass: "container clearfix",
              staticStyle: { padding: "10px 0" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "navbar-header",
                  staticStyle: { "padding-right": "30px", width: "28%" }
                },
                [
                  _c("h1", { staticClass: "navbar-brand" }, [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:;" },
                        on: {
                          click: function($event) {
                            _vm.jumptohome("home")
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "logo-img",
                          attrs: { src: "/static/img/header-logo.png", alt: "" }
                        })
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "navbar-left", staticStyle: { width: "30%" } },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "nav navbar-nav menu",
                      attrs: { id: "nav" }
                    },
                    [
                      _c("li", { staticClass: "xs" }, [
                        _c(
                          "a",
                          {
                            class: "trade" == _vm.actived ? "active" : "",
                            on: {
                              click: function($event) {
                                _vm.jumptotrade("trade")
                              }
                            }
                          },
                          [_c("span", [_vm._v("贸易云")])]
                        )
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "xs" }, [
                        _c(
                          "a",
                          {
                            class: "make" == _vm.actived ? "active" : "",
                            on: {
                              click: function($event) {
                                _vm.jumptomake("make")
                              }
                            }
                          },
                          [_c("span", [_vm._v("制造云")])]
                        )
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm._m(1)
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("loginbox"),
      _vm._v(" "),
      _c("openupbox")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { float: "left", padding: "0" } }, [
      _c("li", { staticClass: "login" }, [
        _c("span", [
          _c(
            "a",
            {
              attrs: {
                href: "https://home.usoftchina.com/",
                target: "_blank",
                rel: "noopener noreferrer"
              }
            },
            [
              _c("img", {
                staticStyle: { width: "18px", "margin-top": "-3px" },
                attrs: { src: "/static/img/Uhome.png", alt: "" }
              }),
              _vm._v("华商云服\n            ")
            ]
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "nav navbar-nav navbar-right phonebox",
        staticStyle: { "margin-right": "2%", "padding-top": "20px" }
      },
      [
        _c("img", {
          staticClass: "phone",
          staticStyle: { height: "45px" },
          attrs: { src: "/static/img/phone.png", alt: "" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12835cef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12835cef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header.vue
// module id = null
// module chunks = 